<template>
    <div>
        <div v-if="criteriaTreeLoaded || questionTreeLoaded">
            <div v-if="filterActiveProject && filterActiveProject.status == 'VALIDATION' && filterActiveProject.PE && level === 0" class="project-container project-level-0 project-id-root">
                <!-- Multiselect for root criteria -->
                <div class="root-criteria-evaluation-block">
                    <label for="root-evaluation" class="criteria-label">
                        Évaluation globale
                    </label>
                    <Multiselect
                        id="root-evaluation"
                        v-model="evalCriteriaMap[fetchRootCriteria(filterActiveProject).id]"
                        :options="getEvaluationOptions"
                        track-by="value" label="text" placeholder="" :searchable="false"
                        @select="e => { updateValidation(fetchRootCriteria(filterActiveProject), evalCriteriaMap[fetchRootCriteria(filterActiveProject).id]) }"
                        class="criteria-multiselect"
                    >
                        <template #option="{ option }">
                            <span>{{ option.value }}</span>
                        </template>
                        <template #singleLabel="{ option }">
                            <span>{{ option.value }}</span>
                        </template>
                    </Multiselect>
                </div>

                <!-- Textarea for root criteria remarks -->
                <div class="root-criteria-evaluation-block">
                    <label for="root-remarks" class="criteria-label">
                        Remarques générales
                    </label>
                    <textarea
                        id="root-remarks"
                        placeholder="Remarques sur l'ensemble du projet..."
                        v-model="evalCommentMap[fetchRootCriteria(filterActiveProject).id]"
                        class="criteria-remark-textarea"
                        @blur="updateValidationComment(fetchRootCriteria(filterActiveProject))"
                    ></textarea>
                </div>
            </div>
            <div v-for="criteria in sortedChildren" :key="criteria.id">
                <div class="project-container" :style="getProjectStyle(criteria)" :class='["project-level-" + level, "project-id-" + criteria.id]'>
                    <div class="project-row" @click="(e) => crunchChildren(e, criteria)">
                        <div class="project-info">
                            <div class="project-reference" :title="criteria.id">{{ criteria.reference }}</div>
                            <div class="project-title">{{ criteria.title }}</div>
                            <div class="criteria-evaluations" v-if="filterActiveProject.status == 'VALIDATION' && filterActiveProject.PE && level === 0">
                                <Multiselect
                                    v-model="evalCriteriaMap[criteria.id]"
                                    :options="getEvaluationOptions"
                                    track-by="value" label="text" placeholder="" :searchable="false"
                                    class="criteria-multiselect"
                                    @select="e => { updateValidation(criteria, evalCriteriaMap[criteria.id]) }"
                                    >
                                    <template #option="{ option }">
                                        <span>{{ option.value }}</span>
                                    </template>
                                    <template #singleLabel="{ option }">
                                        <span>{{ option.value }}</span>
                                    </template>
                                </Multiselect>
                            </div>
                            <div class="criteria-evaluation-block" v-if="filterActiveProject.status == 'VALIDATION' && filterActiveProject.PE && level === 0">
                                <textarea
                                    id="root-remarks"
                                    placeholder="Remarques critère..."
                                    v-model="evalCommentMap[criteria.id]"
                                    class="criteria-remark-textarea-thinner"
                                    @blur="updateValidationComment(criteria)"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div v-if="!criteria.collapsed || filterIsActive">
                        <div v-if="criteria.children_ids && criteria.children_ids.length > 0" class="project-children">
                            <AnswerPage
                                :filter-is-active="filterBlackQuestionsActive || filterUnAnsweredQuestionsActive"
                                v-bind:children="criteria" 
                                v-bind:level="level + 1"
                            />
                        </div>
                        <CriteriaQuestionDisplay 
                            v-bind:questions="getQuestionsForCriteria(criteria.id)" 
                            evaluationType="question" 
                            v-if="hasQuestions(criteria.id)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="!criteriaTreeLoaded && !questionTreeLoaded" class="loading-container">
            <p>Données non chargées/non-existantes...</p>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CriteriaQuestionDisplay from './CriteriaQuestionDisplay.vue'
import Multiselect from "vue-multiselect"
import '../../assets/styles/base.css'
import '../../assets/styles/multiselect.css'

export default {
    name: "AnswerPage",
    props: {
        children: { type: Object, default: null },
        level: { type: Number, default: 0 },
        filterIsActive: { type: Boolean, default: false }
    },
    data() {
        return {
            evalCommentMap: {},
            evalCriteriaMap: {},
        }
    },
    watch: {
        selectedProject: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    // On vide toujours les données locales
                    this.evalCommentMap = {};
                    this.evalCriteriaMap = {};
                    
                    // SEUL LE NIVEAU RACINE FAIT L'APPEL API
                    if (this.level === 0) {
                        this.$store.commit("project/setEvaluationLoaded", false);
                        this.loadEvaluationData();
                    }
                }
            },
            immediate: true
        },
        criteriaEvaluation: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    //console.log("Données store reçues, synchronisation locale...");
                    this.syncEvalComments();
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        ...mapState("auth", ["isAdmin"]),
        ...mapState("project", [
            "criteriaTree", "projectData", "questionTree", "selectedProject",
            "selectedReferentialId", "answerQTest", "evaluationCriteriaColor",
            "evaluationQColor", "filterBlackQuestionsActive", "filterUnAnsweredQuestionsActive", "evaluationLoaded",
            "criteriaEvaluation", "roles", "file", "files", "loading"
        ]),
        ...mapGetters("project", [
            "fetchChildrenCriteria", "readOnlyProject", "isEvaluationView",
            "getEvaluationOptions", "getEvaluationForCriteria", "filterActiveProject",
            "fetchRootCriteria", "userListRightsProject"
        ]),
        criteriaTreeLoaded() {
            //console.log("this.criteriaTree")
            return this.criteriaTree && this.criteriaTree.length > 0
        },
        questionTreeLoaded() {
            //console.log("questionTree :", this.questionTree)
            return this.questionTree && this.questionTree.length > 0
        },
        sortedChildren() {
            const childrenIds = this.children?.children_ids || [];
            if (childrenIds.length === 0) {
                return [];
            }

            let children = this.criteriaTree.filter(criteria =>
                childrenIds.includes(criteria.id)
            );

            children.sort((a, b) => {
                if (a.order_number !== b.order_number && 
                    a.order_number > 0 && b.order_number > 0) {
                    return a.order_number - b.order_number;
                }
                return a.id - b.id;
            });

            if (this.filterIsActive) {
                return children.filter(criteria => this.shouldShowCriteria(criteria));
            }

            return children;
        },
    },
    components: {
        CriteriaQuestionDisplay,
        Multiselect,
    },
   /*  async mounted() {
        // if(this.roles) {
        //     await this.loadUsers().catch((error) => {
        //         console.error("Error loading user list:", error)
        //     })
        // }
        //console.log("Mounted AnswerPage.vue with project:", this.selectedProject)
        //console.log("project data: ", this.filterActiveProject)
        //console.log("evaluation loaded: ", this.evaluationLoaded)
        if (this.selectedProject && this.isEvaluationView && !this.evaluationLoaded) {
                //console.log("Fetching evaluation data...");
                await this.$store.dispatch("project/fetchEvaluationData", { projectId: this.selectedProject })
                    .then(() => {
                         this.$store.commit("project/setEvaluationLoaded", true);
                    })
                    .catch((error) => {
                        console.error("Error loading evaluation data:", error);
                    });
            } else {
                //console.log("Evaluation already loaded in store, syncing...");
                this.syncEvalComments();
            }
    }, */
    created() {
        if(this.level === 0){
            this.fetchData()
        }
    },
    methods: {
        async loadEvaluationData(){
            if (this.selectedProject && this.isEvaluationView && !this.evaluationLoaded) {
                //console.log("Fetching evaluation data...");
                await this.$store.dispatch("project/fetchEvaluationData", { projectId: this.selectedProject })
                    .then(() => {
                         this.$store.commit("project/setEvaluationLoaded", true);
                    })
                    .catch((error) => {
                        console.error("Error loading evaluation data:", error);
                    });
            } else {
                //console.log("Evaluation already loaded in store, syncing...");
                this.syncEvalComments();
            }
        },
        shouldShowCriteria(criteria) {
            if(this.filterBlackQuestionsActive){
                /* if (this.evaluationCriteriaColor[criteria.id] === 0) return true */
                const directQuestions = this.questionTree.filter(q => q.criteria_id === criteria.id)
                const hasMatchingQuestion = directQuestions.some(q => {
                    const hasQuantitativeMatch = q.question_limits['0']?.limit.length>0 && q.question_limits['0']?.sign.length>0 /* && (this.evaluationCriteriaColor[criteria.id] === 0) */
                    const hasQualitativeMatch = q.question_values && q.question_values['0'] && q.question_values['0'].possible_text === "Black"
                    if(hasQualitativeMatch)//console.log(q.question_values);
                    return hasQuantitativeMatch || hasQualitativeMatch
                })
                if (hasMatchingQuestion) return true
            }
            if(this.filterUnAnsweredQuestionsActive){
                const directQuestions = this.questionTree.filter(q => q.criteria_id === criteria.id)
                const hasMatch = directQuestions.some(q =>{
                const ans = this.answerQTest.find(a => a.question_id == q.id)
                if (!ans) return true;
                /* console.log("match conditions :",(ans.answer_color === 66 || ans.user_color === 66) || 
                    (ans.answer_color === 66 && ans.user_color === null && ans.user_value === null && ans.answer_value === null) ||
                    ((ans.user_value == null || ans.user_value === undefined || ans.user_value === '') && '66'.includes(ans.answer_color)) ||
                    ((ans.answer_color == 0 || ans.answer_color == null) && ans.user_color === null && ans.user_value === null && ans.answer_value === null)
                ) */
                const match = 
                    (ans.answer_color === 66 || ans.user_color === 66) || 
                    (ans.answer_color === 66 && ans.user_color === null && ans.user_value === null && ans.answer_value === null) ||
                    ((ans.user_value == null || ans.user_value === undefined || ans.user_value === '') && '66'.includes(ans.answer_color)) ||
                    ((ans.answer_color == 0 || ans.answer_color == null) && ans.user_color === null && ans.user_value === null && ans.answer_value === null)
                    return match
                }) 
                //console.log("this.hasMatch", hasMatch, "\nmatch conditions")
            if(hasMatch)return true;
            }
            if (criteria.children_ids && criteria.children_ids.length > 0) {
                    const childrenCriteria = this.fetchChildrenCriteria(criteria.children_ids)
                    return childrenCriteria.some(child => this.shouldShowCriteria(child))
                }
                return false
        },
        toggleFilter() {
            this.$store.commit("project/toggleBlackQuestionsFilter")
        },
        getProjectStyle(criteria) {
            const levelColors = {
                0: 'var(--zero-color)',
                1: 'var(--one-color)',
                2: 'var(--two-color)',
                3: 'var(--three-color)',
                66: 'var(--sixsix-color)',
                77: 'var(--sevenseven-color)',
                99: 'var(--ninenine-color)',
            }
            const questions = this.getQuestionsForCriteria(criteria.id)
            if(questions && questions.length > 0 && questions[0].is_evaluated === 0){
                return { '--project-border-color': 'var(--sevenseven-color)'};
            }
            const colorCode = this.evaluationCriteriaColor[criteria.id]
            if (colorCode !== undefined && levelColors[colorCode]) {
                return { '--project-border-color': levelColors[colorCode] }
            }else{
                return { '--project-border-color': 'var(--sixsix-color)' }
            }
        },
        async fetchData() {
            if (this.selectedProject && (!this.criteriaTree || this.criteriaTree.length === 0)) {
                await this.$store.dispatch("project/fetchProjectCriteriaList", { id: this.selectedProject })
                await this.$store.dispatch("project/fetchAllAnswers", { id: this.selectedProject })
            }
            if (!this.projectData || this.projectData.length === 0) {
                await this.$store.dispatch("project/fetchProjectList")
            }
        },
        getQuestionsForCriteria(criteriaId) {
            return this.questionTree.filter(question => question.criteria_id === criteriaId)
        },
        hasQuestions(criteriaId) {
            return this.getQuestionsForCriteria(criteriaId).length > 0
        },
        crunchChildren(event, project) {
        if (!project) return;
        const row = event.target.closest('.project-row');
        if (!row) return;
        if (event.target.closest('button, a, input, textarea, select, .multiselect, .btn-icon, .project-actions, .criteria-evaluations')) {
            return;
        }
        this.$store.commit('project/collapseProjectMutation', project.id);
        },
        // async loadUsers() {
            // return true
            // await this.$store.dispatch("project/fetchUserList", this.selectedProject)
            //     .catch((error) => {
            //         console.error("Error loading user list:", error)
            //     })
        // },
        updateValidation(criteria, selectedOption) {
            const criteriaId = criteria.id
            if (!criteriaId) return
            const payload = {
                project_id: this.selectedProject.id,
                criteria_id: criteriaId,
                status: selectedOption.id,
                comment: this.evalCommentMap[criteriaId] || ""
            }
            this.$store.dispatch("project/updateEvaluation", payload)
        },
        updateValidationComment(criteria) {
            const criteriaId = criteria.id
            if (!criteriaId) return
            const payload = {
                project_id: this.selectedProject.id,
                criteria_id: criteriaId,
                comment: this.evalCommentMap[criteriaId] || ""
            }
            this.$store.dispatch("project/updateEvaluation", payload)
        },
        getCriteriaEvaluation(criteriaId) {
            //console.log("this.criteriaEvaluation :",this.criteriaEvaluation)
            return this.getEvaluationForCriteria(criteriaId) || {}
        },
        syncEvalComments() {
            if (this.level === 0) {
                const root = this.fetchRootCriteria(this.filterActiveProject);
                if (root) {
                    this.applyEvaluationToMap(root.id);
                }
            }

            if (this.sortedChildren && this.sortedChildren.length > 0) {
                this.sortedChildren.forEach(criteria => {
                    this.applyEvaluationToMap(criteria.id);
                });
            }
        },
        applyEvaluationToMap(criteriaId) {
            const evalObj = this.getCriteriaEvaluation(criteriaId);
            if (evalObj && evalObj.id !== "NONE") { // On évite de polluer la map avec des "Aucune"
                this.evalCommentMap[criteriaId] = evalObj.comment || "";
                const selectedOption = this.getEvaluationOptions.find(opt => opt.id === evalObj.status);
                this.evalCriteriaMap[criteriaId] = selectedOption || null;
            }
        },
    }
}
</script>

<style scoped>
.criteria-tree {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.loading-container {
    text-align: center;
    padding: 20px;
    color: #666;
}

.project-container {
    margin-bottom: 15px;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    border-left: 4px solid var(--project-border-color);
    max-width:100%;
    word-break: break-word;
}



.project-container:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.project-level-0 {
    margin-left:0;
    padding: 1rem 0 0.5rem 1rem;
}

.project-level-1 {
    /* border-left: 4px solid var(--left2-color); */
    margin-left: 24px;
}

.project-level-2 {
    /* border-left: 4px solid var(--left3-color); */
    margin-left: 48px;
}

.project-level-3 {
    /* border-left: 4px solid var(--left4-color); */
    margin-left: 72px;
}

.project-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 13px;
    /* border-bottom: 1px solid #f0f0f0; */
    margin-bottom: 7px;
    cursor: pointer;
}

.project-info {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 4px 6px;
    gap: 50px;
}

.project-reference {
    background: #f8f9fa;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 12px;
    min-width: 40px;
    max-height: 35px;
    text-align: center;
    margin-right: 20px;
}


.project-title {
    font-size: 16px;
    margin-left: 50px;
    font-weight: 500;
    text-align: left;
}

.project-row:hover .project-actions,
.project-actions:focus-within {
    opacity: 1;
    pointer-events: auto;
}

.btn-icon:hover {
    color: var(--primary-color);
}

.project-children {
    margin: 0;
    padding: 0;
}

:deep(.multiselect),
:deep(.multiselect__tags),
:deep(.multiselect__option),
:deep(.multiselect__option:hover) {
  cursor: pointer;
}

:deep(.multiselect__option){
    background-color: var(--bg-color);
}

:deep(.multiselect__option--selected, .multiselect__option--highlight ){
    color: black;
}
:deep(.multiselect__content-wrapper){
    border-radius: 0 14px 14px 14px;
}

:deep(.multiselect__content){
    min-width: 20%;
}
/* Pour s'assurer que les questions sont bien visibles */
/* .criteria-questions {
    padding: 10px 15px;
    margin-top: 5px;
    border-top: 1px dashed #eee;
} */

.root-criteria-evaluation-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 18px;
    max-width: 480px;
}

.criteria-evaluation-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
    /* margin-bottom: 18px; */
    max-width: 480px;
}

.criteria-label {
    font-weight: 500;
    color: #444;
    margin-bottom: 2px;
    font-size: 15px;
}

.criteria-multiselect {
    min-width: 180px;
    max-width: 320px;
}

.criteria-remark-textarea {
    min-width: 180px;
    max-width: 480px;
    min-height: 60px;
    padding: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 7px;
    background-color: #f8f9fa;
    font-size: 1rem;
    resize: vertical;
    margin-bottom: 4px;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.criteria-remark-textarea:focus {
    border-color: #007bff;
    outline: none;
    background-color: #fff;
}
.criteria-remark-textarea-thinner {
    min-width: 250px;
    max-width: 480px;
    min-height: 30px;
    max-height: 40px;
    padding: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 7px;
    background-color: #f8f9fa;
    font-size: 1rem;
    resize: vertical;
    margin-bottom: 4px;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.criteria-remark-textarea-thinner:focus {
    border-color: #007bff;
    outline: none;
    background-color: #fff;
}
</style>
